/* unplugin-vue-components disabled */import { render, staticRenderFns } from "./audio-play.vue?vue&type=template&id=7897a952&scoped=true&"
import script from "./audio-play.vue?vue&type=script&lang=js&"
export * from "./audio-play.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7897a952",
  null
  
)

export default component.exports